module.exports = __webpack_public_path__ + "img/QD.1e262e45.png";